import { createContext } from 'react'

const FightRoundsContext = createContext(null)

export default FightRoundsContext;